
<div
  class="lobby-table-game-specific-wrapper lobbyTableGameSpecificWrapper--3fAEk desktop--1Txr1"
  data-role="lobby-table-game-specific-wrapper"
>
  <div class="RecentResults--3Im4X" data-role="recent-results">
    <svg
      v-for="(result, index) in tableauResultat"
      :key="index"
      class="item--1_3sq"
      viewBox="0 0 56 53"
      data-role="recent-result"
    >
      <defs>
        <linearGradient id="hgdzfroyju" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop stop-color="#F1E07F" offset="0%"></stop>
          <stop stop-color="#BA8433" offset="100%"></stop>
        </linearGradient>
        <linearGradient id="92szj2o70m" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop stop-color="#504E49" offset="0%"></stop>
          <stop stop-color="#312F28" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g transform="translate(2 12)">
        <rect
          :fill-opacity="result.multiplier ? '0.8' : index == 0 ? '0.12' : '0.04'"
          :fill="result.multiplier ? 'url(#hgdzfroyju)' : '#FFFFFF'"
          width="52"
          height="40"
          rx="2"
          :stroke-width="index == 0 ? '2' : ''"
          :stroke="index == 0 ? '#FFFFFF' : ''"
        ></rect>
        <text
          font-family="Inter, Arial, sans-serif"
          font-size="24"
          :font-weight="index == 0 ? 'bold' : '400'"
          fill="#FFF"
          text-anchor="middle"
        >
          <tspan x="26" y="27">{{ getTotalResultat(result.value) }}</tspan>
        </text>
      </g>
      <g v-if="result.multiplier" transform="translate(0 -1)">
        <rect
          stroke="#BAA258"
          fill="url(#92szj2o70m)"
          fill-rule="nonzero"
          x="6"
          y="1.5"
          width="42"
          height="16"
          rx="8"
        ></rect>
        <text
          font-family="Inter, Arial, sans-serif"
          font-size="14"
          font-weight="bold"
          fill="#D9D9D8"
          text-anchor="middle"
        >
          <tspan x="27" y="14">{{ result.multiplier }}x</tspan>
        </text>
      </g>
    </svg>
  </div>
</div>
